export default __webpack_public_path__ + "static/logo-6dd9ea95196957d65967d4af99f206c6.png";